import axios from 'axios';

import { getUserUuidHeaders } from '../../../utils/httpUtils';
import { getUrls } from '../../../utils/url';

const { api } = getUrls();

export const getStudentSelf = async (meetingId, userUuid) => {
    const response = await axios.get(`${api}/api/zoom/get_class_student_self`, {
        params: {
            meeting_id: meetingId
        },
        headers: getUserUuidHeaders(userUuid)
    });

    return response.data;
};
